<template>
  <div>
    <custom-actions show-back>
      <el-form
        class="global-form shoufa-form"
        :model="formData"
        :rules="rules"
        ref="form"
        label-width="160px"
        v-loading="loading"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item prop="typeName" label="类型名称">
              <el-input
                v-model="formData.typeName"
                placeholder="请输入类型名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="12">
          <el-col :span="12">
            <el-form-item prop="upTypeId" label="上级类型">
              <el-cascader
                v-model="formData.upTypeId"
                :options="typeTreeList"
                :props="{ emitPath: false, label: 'typeName', value: 'typeId', children: 'childNode', checkStrictly: true }"
                placeholder="请选择类型"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="类型图片" prop="typeImage">
              <div v-if="formData.typeImage" class="images-wrap">
                <i class="el-icon-error close-icon" @click="delImage"></i>
                <el-image
                  style="width: 100%; height: 100%"
                  :src="formData.typeImage"
                  :preview-src-list="[formData.typeImage]"
                  fit="cover"
                />
              </div>
              <el-upload
                v-else
                class="upload-demo"
                :action="$apis.common.uploadUrl"
                :limit="1"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                list-type="picture-card"
              >
                <i class="el-icon-plus"></i>

                <div slot="tip" class="el-upload__tip">
                  图片大小不能超过10MB~
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary"   @click="submit"
                >提交</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'GrainTypeAdd',

  data () {
    return {
      typeTreeList: [],
      typeArr: [],
      formData: {
        typeId: '',
        upTypeId: '',
        typeName: '',
        typeImage: ''
      },
      rules: {
        typeName: [
          {
            required: true,
            message: '请输入类型名称',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,

      dialogVisible: false
    }
  },
  created () {
    if (this.typeId) {
      this.loadData()
    }
    this.loadGrainTreeList()
  },
  computed: {
    typeId () {
      return this.$route.query.typeId
    }
  },
  methods: {
    delImage () {
      this.formData.typeImage = ''
    },
    handleSuccess (res) {
      console.log('res: ', res)
      const file = res.data
      this.formData.typeImage = file.filePrefix + file.fileUrl
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.grainType.selectYxOilTypeByTypeId, {
          params: { typeId: this.typeId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadGrainTreeList() {
      this.$axios.get(this.$apis.grainType.selectYxOilTypeByTree).then(res => {
        this.typeTreeList = res
      })
    },
    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.grainType.insertYxOilType
          if (this.typeId) {
            url = this.$apis.grainType.updateYxOilType
          }
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
